import axios from "axios";
// @ts-ignore
import { pathOr, includes } from "ramda";
import { goToRoute, sleep } from "./utils";

axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.withCredentials = true;
// axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
let isRefreshTokenInProgress = false;

class httpService {
  static doLogout = async () => {
    localStorage.clear();
    goToRoute("dashboard", {}, {}, false);
    await sleep(500);
    location.reload();
  };

  static async getRefreshToken() {
    if (isRefreshTokenInProgress) return;

    try {
      isRefreshTokenInProgress = true;
      axios.defaults.withCredentials = true;
      const url = process.env.VUE_APP_API_URL + "v1/refresh-cookie-token";
      const response = await axios.post(url);
      return response;
    } catch (error) {
      if (error) {
        const statusCode = pathOr(401, ["response", "status"], error);
        if (includes(statusCode, [401, 412])) {
          this.doLogout();
          return false;
        }
      }
    } finally {
      isRefreshTokenInProgress = false;
    }
  }

  static async generateHeaders(extraHeaders: any = {}) {
    const config: any = {
      headers: { Accept: "application/json" },
    };
    for (const [key, value] of Object.entries(extraHeaders)) {
      config.headers[key] = value;
    }
    return config;
  }

  static async get(
    url: string,
    params: any = false,
    headers: any = {},
    token = true
  ) {
    let insideHeaders = {};
    if (token) {
      insideHeaders = await this.generateHeaders(headers);
      if (!insideHeaders) this.doLogout();
    }
    if (params) {
      //@ts-ignore
      insideHeaders.params = params;
    }
    axios.defaults.withCredentials = true;
    return this.response(axios.get(url, { ...insideHeaders, ...headers }));
  }

  static async post(
    url: string,
    data: any,
    headers = {},
    token = true,
    config = {}
  ) {
    if (token) {
      headers = await this.generateHeaders(headers);
      if (!headers) return false;
    }
    axios.defaults.withCredentials = true;
    return this.response(
      axios.post(url, data, {
        ...headers,
        ...config,
      })
    );
  }

  static async put(url: string, data: any, headers = {}, token = true) {
    if (token) {
      headers = await this.generateHeaders(headers);
      if (!headers) return false;
    }
    axios.defaults.withCredentials = true;
    return this.response(axios.put(url, data, headers));
  }

  static async patch(
    url: string,
    data: any,
    headers = {},
    token = true,
    options = {}
  ) {
    if (token) {
      headers = await this.generateHeaders(headers);
      if (!headers) return false;
    }
    axios.defaults.withCredentials = true;
    return this.response(axios.patch(url, data, { ...headers, ...options }));
  }

  static async all(url: any) {
    axios.defaults.withCredentials = true;
    return await this.response(axios.all(url));
  }

  static async delete(url: string, data: any, headers: any = {}, token = true) {
    if (token) {
      headers = await this.generateHeaders(headers);
      if (!headers) return false;
    }
    if (data) {
      headers.params = data;
    }
    axios.defaults.withCredentials = true;
    return this.response(axios.delete(url, headers));
  }

  static response(res: any) {
    return res
      .then((response: any) => response)
      .catch(async (error: any) => {
        const status = pathOr(null, ["response", "status"], error);
        const accessibility = pathOr(
          true,
          ["response", "data", "accessibility"],
          error
        );
        if (status === 401) {
          if (!accessibility) {
            this.doLogout();
            return;
          }

          await this.getRefreshToken();

          await sleep(1000);

          // recall the last request
          return this.response(axios(error.config));
        } else {
          throw error;
        }
      });
  }
}

export default httpService;
